import { render, staticRenderFns } from "./ReportGenerationRequestForm.vue?vue&type=template&id=01b28ea8&"
import script from "./ReportGenerationRequestForm.vue?vue&type=script&lang=js&"
export * from "./ReportGenerationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports